export enum InPriceStepType {
  Percentage = 0,
  Charge = 1,
}
